"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartHashing = exports.sha1Hash = exports.sha256SmartHash = void 0;
const crypto = __importStar(require("crypto"));
const sha256HashedRegex = /^[a-f0-9]{64}$/i;
function sha256SmartHash(value) {
    if (sha256HashedRegex.test(value)) {
        return value;
    }
    return crypto.createHash('sha256').update(value).digest('hex');
}
exports.sha256SmartHash = sha256SmartHash;
function sha1Hash(value) {
    return crypto.createHash('sha1').update(value).digest('hex');
}
exports.sha1Hash = sha1Hash;
class SmartHashing {
    constructor(encryptionMethod) {
        this.encryptionMethod = encryptionMethod;
        this.preHashed = false;
    }
    isAlreadyHashed(value) {
        this.preHashed = sha256HashedRegex.test(value);
        return this.preHashed;
    }
    hash(value) {
        if (this.preHashed) {
            return value;
        }
        return crypto.createHash('sha256').update(value).digest('hex');
    }
}
exports.SmartHashing = SmartHashing;
//# sourceMappingURL=hashing-utils.js.map